export { default as PermissionRole } from './page'


// WEBPACK FOOTER //
// ./src/pages/PermissionRole/index.js